import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class NotificationService {

    listNotifications(data, params) {
        return axiosInstance.get(`${config.api.version}/push/${data}/notifications`, {
            params: {
                page: params.page,
                limit: params.rows
            }
        });
    }

    getNotification(id, data, params, filters) {
        return axiosInstance.get(`${config.api.version}/push/${data}/notifications/${id}`, {
            params: {
                page: params.page,
                limit: params.rows,
                search: filters.search,
                status: filters.status
            }
        });
    }

    enviarNotificacao(data, formData) {
        return axiosInstance.post(`${config.api.version}/push/${data}/notifications`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    uploadAvatar(data, image) {
        return axiosInstance.post(`${config.api.version}/image/${data}/avatar`, image, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    uploadMultiple(data, images) {
        return axiosInstance.post(`${config.api.version}/image/${data}/upload-multiple`, images, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    deleteMultiple(data, images) {
        return axiosInstance.post(`${config.api.version}/image/${data}/delete-multiple`, images);
    }

}
